import { render, staticRenderFns } from "./DialogModal.vue?vue&type=template&id=21b59c16&scoped=true&"
import script from "./DialogModal.vue?vue&type=script&lang=ts&"
export * from "./DialogModal.vue?vue&type=script&lang=ts&"
import style0 from "./DialogModal.vue?vue&type=style&index=0&id=21b59c16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b59c16",
  null
  
)

export default component.exports